import {ReactComponent as QuestionIcon} from '@/assets/svgs/QuestionIcon.svg'
import Tooltip from '@/components/UI/tooltip'
import {colors} from '@/constants'
import React from 'react'
import {Stack} from '@mui/material'

interface QuestionTooltipProps {
  id: string
  children: any
  styles?: {[key: string]: string}
  top?: string
  isClick?: boolean
  svgColor?: string | null
}

const Index = ({
  id,
  children,
  styles,
  isClick = false,
  top = '-10px',
  svgColor = null,
}: QuestionTooltipProps) => {
  return (
    <Stack
      sx={{
        '&:hover svg': {
          fill: colors.orange,
        },
      }}
      position="absolute"
      top={top}
      right="-30px">
      <QuestionIcon data-tooltip-id={id} fill={svgColor || colors.white} />
      <Tooltip isClick={isClick} position="fixed" styles={styles} id={id}>
        {children}
      </Tooltip>
    </Stack>
  )
}

export default Index
